import CryptoJS from "crypto-js";
import { settings } from "../data/settings";

// Fonction pour vérifier le mot de passe
export const verifyPassword = (password) => {
  const storedHashedPassword = settings.adminPassword;

  const hashedInputPassword = CryptoJS.MD5(password).toString(
    CryptoJS.enc.Base64
  );
  return hashedInputPassword === storedHashedPassword;
};

// Fonction pour hacher un mot de passe à l'initialisation
export const hashPassword = (password) => {
  const hashedPassword = CryptoJS.MD5(password).toString(CryptoJS.enc.Base64);
  localStorage.setItem("adminPassword", hashedPassword);
  return hashedPassword;
};

/**
 * Enregistre une session admin valide avec une date d'expiration.
 */
export const setAdminSession = () => {
  const expirationTime = Date.now() + 24 * 60 * 60 * 1000; // 24 heures
  localStorage.setItem(
    "adminSession",
    JSON.stringify({ expires: expirationTime })
  );
};

/**
 * Vérifie si la session admin est toujours valide.
 * @returns {boolean}
 */
export const isAdminSessionValid = () => {
  const session = JSON.parse(localStorage.getItem("adminSession"));
  if (!session) return false;
  return Date.now() < session.expires;
};
